<template>
  <Modal
    ref="modal"
    title="New Template"
    action="Save"
    actionColor="indigo"
    @closeModal="handleCancelSettings"
    @handleAction="createEmailTemplate"
  >
    <TextInput
      label="Template Name"
      :modelValue="email.templateName"
      @update:modelValue="value => (email.templateName = value)"
    />
    <TextInput
      class="mt-4"
      ref="subjectInput"
      label="Email Subject"
      placeholder="Greetings from earth!"
      :modelValue="email.subject"
      @update:modelValue="value => (email.subject = value)"
    />
    <div class="mt-8 flex space-x-3">
      <div class="min-w-0 flex-1">
        <QuillInput
          ref="quillInput"
          name="new-email"
          label="New Email"
          :labelSrOnly="true"
          size="large"
          v-model="email.body"
        />
      </div>
    </div>
    <SelectMenu
      class="mt-4"
      label="Merge Tags"
      :initialValue="selectMenuInitialValue"
      :options="mergeTags"
      @selectedOption="insertMergeTag($event)"
    />
  </Modal>
</template>

<script>
import Modal from '../../shared/Modal.vue';
import { sanitizeRichText } from '../../../utilities/sanitization';
import QuillInput from '../../shared/QuillInput.vue';

export default {
  components: {
    Modal,
    QuillInput,
  },
  data() {
    return {
      email: {
        templateName: '',
        subject: '',
        body: '',
      },
      selectMenuInitialValue: 'Insert a merge tag...',
      mergeTags: [
        '{{contact.name}}',
        '{{contact.first_name}}',
        '{{contact.last_name}}',
        '{{contact.email}}',
        '{{contact.phone_number}}',
        '{{contact.source}}',
        '{{contact.referral_link}}',
        '{{team.company}}',
      ],
    };
  },
  methods: {
    sanitize(html) {
      return sanitizeRichText(html);
    },
    insertMergeTag(tag) {
      if (tag === this.selectMenuInitialValue) return;
      this.$refs.quillInput.insertTextAtCursor(tag);
    },
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
    createEmailTemplate() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/email_templates/`, {
        method: 'POST',
        body: JSON.stringify({
          id: self.email.templateId,
          name: self.email.templateName,
          subject: self.email.subject,
          body: self.email.body,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Email template saved',
              alertDescription:
                'Your Email Template email was successfully saved.  Use the button below to dismiss this alert.',
            });
            self.$emit('handleSaveSettings');
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Email template save error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
